<template>
    <div>
        <v-snackbar
            :timeout="actionDuration"
            v-model="actionDialog"
            centered
            top
            elevation="20"
            :color="actionColor"
            class="mt-n9">
            <div 
                class="text-center sansation_subtitle py-1 px-12"
                :class="actionColor == 'success' ? 'primary--text text--darken-4' : 'white--text'"
                v-html="actionMessage">
            </div>
        </v-snackbar>
                    
        <v-btn 
            color="primary" 
            class="accent--text"
            dark
            :loading="show_loader"
            @click="reportGen()">
            Generate Report
        </v-btn>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';

    import { saveAs } from 'file-saver';

    export default {
        name: 'NmReportGen',

        data () {
            return {
                actionDialog: false,
                actionMessage: '',
                actionColor: 'error',
                actionDuration: 4000,
                show_loader: false
            }
        },
        
        methods: {
            reportGen: async function () {
                try {
                    this.show_loader = true
					const generate_report = await axios.get(`${appUrls.api}/api/report_nm_ensembles`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})

					if ( generate_report.data.outcome ) {
                        this.show_loader = false;
                        const this_fileData = new Buffer(generate_report.data.buffer_data, 'base64');
                        const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const this_fileName = generate_report.data.file_name;
                        
                        const this_blob = new Blob([this_fileData], {type: this_fileType});
                        saveAs(this_blob, this_fileName);

                        this.actionDialog = true
                        this.actionColor = 'success'
                        this.actionMessage = generate_report.data.message
                        
					} else {
                        this.show_loader = false
                        this.actionDialog = true
                        this.actionMessage = generate_report.data.message
                    }
                } catch ( err ) {
                    console.log(err);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/NmReportGen.vue